import React from 'react';
import PageHeader from '€components/PageHeader';
import ContentLayout from '€layouts/ContentLayout';
import { Routes } from '€lib/routing';

const UserProfileHeader: React.FC = () => (
    <ContentLayout.Header mx={{ xs: 0, sm: 0 }}>
        <PageHeader backPath={Routes.Dashboard} backText={'Back to Dashboard'} px={0} />
    </ContentLayout.Header>
);
export default UserProfileHeader;
